var React = require('react');

function IconError (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100 0a100 100 0 1 0 100 100A100 100 0 0 0 100 0zm12.8 32l-4.6 92.8H92.4L87.6 32zM110 164.2c-2.4 2.6-5.6 3.8-9.8 3.8s-7.6-1.2-10-3.6-3.6-5.8-3.6-10.4 1.2-8 3.6-10.2 5.8-3.6 10.2-3.6 7.6 1.2 10 3.6 3.4 5.8 3.4 10.2-1.4 7.6-3.8 10.2z"}));
}

IconError.defaultProps = {"className":"icon error","viewBox":"0 0 200 200"};

module.exports = IconError;

IconError.default = IconError;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-error.svg
// module id = 524
// module chunks = 0